import activityTypes from '../constants/activityTypes';
import physical_awareness from '../assets/images/cogs/physical_awareness.png';
import positive_relationships from '../assets/images/cogs/positive_relationships.png';
import self_awareness from '../assets/images/cogs/self_awareness.png';
import self_management from '../assets/images/cogs/self_management.png';
import social_awareness from '../assets/images/cogs/social_awareness.png';
import wise_decisions from '../assets/images/cogs/wise_decisions.png';
import QRCodeUtils from './QrCodeUtils';

export const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
};

export const getActivityByType = (type, key = null) => {
    const data = activityTypes
        .filter((activity) => {
            return activity._id === type;
        })
        .shift();

    if (data && key) {
        return data[key];
    } else {
        return data;
    }
};

export const extractDataAttributes = (props) => {
    return Object.keys(props)
        .filter((name) => name.includes('data-'))
        .reduce((obj, key) => {
            return {
                ...obj,
                [key]: props[key],
            };
        }, {});
};

export const getCogImage = (cogName) => {
    const images = {
        physical_awareness: physical_awareness,
        positive_relationships: positive_relationships,
        self_awareness: self_awareness,
        self_management: self_management,
        social_awareness: social_awareness,
        wise_decisions: wise_decisions,
    };

    const name = cogName.replace(' ', '_');
    return images[name];
};

export const lessonGroupsToAreasAndFoci = (areas, lessonGroups) => {
    const names = lessonGroups.map((group) => {
        const groupArea = areas.find((area) => {
            return area.focus.find((focus) => +focus.focusId === +group.focusId);
        });
        const focusName = groupArea.focus.find((focus) => +focus.focusId === +group.focusId).focusName;

        return [groupArea.areaName, focusName];
    });
    const temp = names[0].map((col, i) => names.map((row) => row[i]));
    return [[...new Set(temp[0])], [...new Set(temp[1])]];
};

export const numbersToSelectOptions = (max) => {
    return [...Array(max)].map((a, j) => {
        let index = j + 1;
        return {
            label: index,
            value: index,
        };
    });
};

export const resolveObjectPath = (path, obj = {}, separator = '.') => {
    var objectKeys = Array.isArray(path) ? path : path.split(separator);
    return objectKeys.reduce(
        (currentSubObject, currentObjectKey) => currentSubObject && currentSubObject[currentObjectKey],
        obj
    );
};

export const exportToCSV = (csv, filename) => {
    let csvFile;
    let downloadLink;

    // CSV file
    csvFile = new Blob(['\ufeff', csv], { type: 'text/csv' });

    // Download link
    downloadLink = document.createElement('a');

    // File name
    downloadLink.download = filename;

    // Create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);

    // Hide download link
    downloadLink.style.display = 'none';

    // Add the link to DOM
    document.body.appendChild(downloadLink);

    // Click download link
    downloadLink.click();
};

export const ServerLink = window.location.hostname.includes('lifeskillsgo')
    ? window.location.hostname.includes('login-staging')
        ? 'https://staging.lifeskillsgo.com'
        : 'https://platform.lifeskillsgo.com'
    : window.location.origin;

export const WSServerLink = window.location.hostname.includes('lifeskillsgo')
    ? window.location.hostname.includes('login-staging')
        ? 'https://staging.lifeskillsgo.com'
        : 'https://ws.lifeskillsgo.com'
    : window.location.origin;

export const StudentAppLink = window.location.hostname.includes('lifeskillsgo')
    ? window.location.hostname.includes('login-staging')
        ? '//student-staging.lifeskillsgo.com'
        : '//student.lifeskillsgo.com'
    : `//${window.location.hostname}:3001`;

export const ShopLink = window.location.hostname.includes('lifeskillsgo')
    ? window.location.hostname.includes('login-staging')
        ? '//shop-staging.lifeskillsgo.com'
        : '//shop.lifeskillsgo.com'
    : `//${window.location.hostname}:3004`;

export default {
    getActivityByType: getActivityByType,
    QRCodeUtils,
};
